import {
  GENERICS_HTTP_STATUS_CODES_MAPPER,
  getGenericBlockerErrors,
  HttpStatusMapper,
} from '@repo/core'
import {
  consolidatedPortfolioActions,
  consolidatedPortfolioDownloadActions,
  globalPositionActions,
  globalPositionDownloadActions,
} from '../../slices'

export const httpStatusErrorCodesMapper: HttpStatusMapper = {
  [globalPositionActions.getResponse.type]: {
    ...getGenericBlockerErrors([400, 404, 422, 501, 502, 503, 504]),
  },
  [globalPositionDownloadActions.downloadResponse.type]: {
    ...getGenericBlockerErrors([400, 404, 422, 500, 501, 502, 503, 504]),
  },
  [consolidatedPortfolioActions.getResponse.type]: {
    ...getGenericBlockerErrors([400, 404, 422, 501, 502, 503, 504]),
  },
  [consolidatedPortfolioDownloadActions.downloadResponse.type]: {
    ...getGenericBlockerErrors([400, 404, 422, 500, 501, 502, 503, 504]),
  },
  GENERICS: GENERICS_HTTP_STATUS_CODES_MAPPER,
}
